export default {
  id: null,
  regulationAutoID: null,
  isFullIndenization: null,
  valueBodywork: null,
  valueTapestry: null,
  valuePainting: null,
  valueElectrical: null,
  valueMechanical: null,
  valueThird: null,
  valueGlassware: null,
  withSuppliedParts: null,
  withoutSuppliedParts: null,
  valueTotalBudgeted: null,
  autoModelID: null,
  autoTypeID: null,
  brandID: null,
  budgetNumber: null,
  year: null,
  color: null,
  plate: null,
  chassis: null,
  hasFrontSuspensionDamage: null,
  hasRearSuspensionDamage: null,
  hasEngineDamage: null,
  hasCoolingSystemsDamage: null,
  fullIndenization: null,
  cnpj: null,
  contactName: null,
  telephone: null,
  observation: null,
  workshopEmail: null,
  mechanicalDamageInformation: null
}



// WEBPACK FOOTER //
// ./src/shared/models/regulation/auto/sinisterworkshopreturn-model.js